import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { PartAttachmentInfo } from '../part-attachment-info/part-attachment-info.module';
import { loadURLSVGs } from '@dds-uicore/all'
import { HttpClient } from '@angular/common/http';
import { FileExplorerService } from '../services/file-explorer.service';
import { FileExplorerOut } from '../model/file-explorer-out';
import { DataService } from '../data.service';
import { FileElement } from '../model/file-element';
import { FileCatalystAPIService } from '../services/file-catalyst-api.service';
import { UserPrivilegeInfo } from '../model/user-privilege-info';
import { AgileSDKService } from '../services/agile-sdk.service';
import { FileTypeCodeInfo } from '../model/file-type-code-info.model';

import { AgileFileInfo } from '../model/agile-file-info';

import { AntiVirusScanService } from '../services/anti-virus-scan.service';

import { UploadStatusModel } from '../model/upload-status-model';
import { HardwareRelationshipMappingInfo } from '../model/agile-file-upload-response';
import { HomeComponent } from '../home/home.component';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-attach-file',
  templateUrl: './attach-file.component.html',
  styleUrls: ['./attach-file.component.css']
})
export class AttachFileComponent implements OnInit {
  @ViewChild("modalbutton", { static: false }) modalbutton: ElementRef;
  @ViewChild("progressbar") progressbar: ElementRef;
  @ViewChild("closeModal", { static: false }) closeModal: ElementRef;
  partAttachmentInfo: PartAttachmentInfo[];
  selectedItems: string[];
  bodyText: string;
  fileCodesFilters: string[];
  fileTypeCodes: string[];
  accToggleValue: boolean
  selectedFiles: FileElement[] = [];
  selectedFilesString: string[] = [];
  uploadFileInfo: AgileFileInfo[] = [];
  uploadFilesError: boolean = false;
  uploadFilesErrorMsg: string = ''
  inProgressStatus:string = 'inprogress';
  completeStatus:string = 'complete';
  failedStatus:string = 'failed';
  notStartedStatus:string = 'notstarted';

  uploadLoadingModalMessage: string = "Loading.. Please wait.";

  // isDisabled:boolean = false;

  userPrivilegeInfo: UserPrivilegeInfo;
  hasUploadPrivilege: boolean

  count: number;

  checkAll: boolean = false;

  attachmentInfoDynamicForm: FormGroup;

  fileNameTest: any

  fileTypeCodeRes: FileTypeCodeInfo[] = [];

  fileExtension: string[] = [];
  fileExtensionRowErr: string[] = [];
  mandatoryFieldErrMsg: string = "";
  partAttRes: PartAttachmentInfo[];

  constructor(private router: Router, private formBuilder: FormBuilder, private dataService: DataService
    , private fcService: FileCatalystAPIService) {

    this.attachmentInfoDynamicForm = this.formBuilder.group({
      attachments: new FormArray([])
    });



   

    this.fileCodesFilters = ['Internal', 'External']

    this.fileTypeCodes = [];

  }

  ngOnInit(): void {

    

    // this.getFileTypeCodeRes();
    this.accToggleValue = this.dataService.getToggleValue();
    if (this.accToggleValue) {
      console.log('building the form array for acceleration')
      this.t.push(this.formBuilder.group({
        fileCodeFilter: [''],
        fileTypeCode: [''],
        fileNameWithPath: { value: [''], disabled: true },
        digitalSign: { value: false, disabled: true }
        // makeZip:['']
      }))
    } else {
      console.log('building the form array for non-acceleration')
      this.t.push(this.formBuilder.group({
        fileCodeFilter: [''],
        fileTypeCode: [''],
        fileNameWithPath: { value: Array<File>(), disabled: true },
        digitalSign: { value: false, disabled: true },
        fileSource:['']
        // makeZip:['']
      }))
    }


    // console.log('------------------ enabling ')
    // this.t.at(0).get('digitalSign').enable();

    loadURLSVGs([
      // "https://uicore.dellcdn.com/1.3.3/svgs/dds__folder.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__search.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__document.svg",

    ], true);
    this.userPrivilegeInfo = this.dataService.getUserPrivilegeInfo()
    this.hasUploadPrivilege = this.userPrivilegeInfo.hasUploadPrivilege

    // const modal = document.querySelectorAll('[data-toggle=\"dds__modal1\"]');
    // new Modal(modal[0],{backdrop :'static'});

    // this.getData()
    // .then((data) => this.createOptions(data))
    // .then((options) => { 

    //   // then and initilize DDS Table element 
    //   const tableElement = document.querySelectorAll("[data-table=\"dds__table\"]");
    //   new Table(tableElement[0], options);
    // });
    this.partAttRes = this.dataService.getPartAttachments();
  }

  get f() { return this.attachmentInfoDynamicForm.controls; }
  get t() { return this.f.attachments as FormArray; }

  selected = [
    { id: 5, name: 'Angular' },
    { id: 6, name: 'Vue' }
  ];
  getSelectedValue() {
    // console.log(this.selected);
  }

  OSLang() {
    this.router.navigateByUrl('/os-lang');
  }

  onSelection(fileName: string) {

  }

  onDownload() {
    if (this.checkAll) {
      console.log('All Files ', this.partAttachmentInfo)
    } else {
      console.log(this.partAttachmentInfo)
    }
  }
  onFileChange(event,i:number){
    if(event.target.files.length>0){
      console.log('index in onFile Change event ',i)
      const file = event.target.files[0];
      this.t.at(i).patchValue({ fileSource:file })
     
    }
  }
  onCheckAll() {
    this.checkAll = !this.checkAll;
  }

  addChild(i: number) {
    // this.count++;
    console.log('in Add child ', i)
    console.log('Here 2')
    this.accToggleValue = this.dataService.getToggleValue();
    if (this.accToggleValue) {
      if (this.t.length < 5) {
        this.t.push(this.formBuilder.group({
          fileCodeFilter: [''],
          fileTypeCode: [''],
          fileNameWithPath: { value: [''], disabled: true },
          digitalSign: { value: false, disabled: true }
          // makeZip:['']
        }));
      }
    } else {
      if (this.t.length < 5) {
        this.t.push(this.formBuilder.group({
          fileCodeFilter: [''],
          fileTypeCode: [''],
          fileNameWithPath: { value: Array<File>(), disabled: true },
          digitalSign: { value: false, disabled: true },
          fileSource:['']
          // makeZip:['']
        }));
      }
    }
    // this.f['digitalSign'].disable();
    // this.f.digitalSign.disable();
    // if(this.t.length < 5)
    // {
    //   this.t.push(this.formBuilder.group({
    //     fileCodeFilter:[''],
    //     fileTypeCode:[''],
    //     fileNameWithPath:[''],
    //     digitalSign:['']
    //     // makeZip:['']
    //   }));
    // }
    // this.fileExplorerService.clearMap();
  }

  removeChild(i: number) {
    console.log('in Remove child ')
    this.selectedFilesString.forEach((value, index) => {
      value = value.substring(value.lastIndexOf('/') + 1);
      console.log('value ', value)
      console.log('File Name With Path ', this.t.at(i).get('fileNameWithPath'))
      if (this.t.at(i).get('fileNameWithPath').value === value) {
        console.log('Inside IF')
        this.selectedFilesString.splice(index, 1);
      }
    })
    this.t.removeAt(i);
    console.log('selected files ', this.selectedFilesString)
  }


  uploadFiles1(){
   
   
    // let hardwareRelMap:HardwareRelationshipMappingInfo = {partNumber:'005CT',partRevision:'X09-00',componentIdsSet:['a','b'],pnpIdStringInfoSet:[],hardwarePnPMappingSet:['a::pnp1'],hasInfo:true};
    // this.dataService.setHardwareRelInfo(hardwareRelMap);
    // this.router.navigate(['relmapping'], { skipLocationChange: true });
    // this.homeComp.openTAModal();

  }

  uploadFiles() {
    this.partAttRes = this.dataService.getPartAttachments();
    let tempFileTypeCodes = [];
    let tempFileNames = [];
    this.fileExtensionRowErr = [];
    this.uploadFileInfo = [];
    console.log('Form values ', this.t.value)
    this.uploadFilesError = false
    for (let i = 0; i < this.t.value.length; i++) {
      let localPartAttRes: PartAttachmentInfo[] = [];
      console.log('this.t.at(i).value ', this.t.at(i).value)
      console.log('this.t.at(i).value.fileNameWithPath ', this.t.at(i).value.fileNameWithPath)
      console.log('this.t.at(i).value.fileTypeCode ', this.t.at(i).value.fileTypeCode)
      console.log('this.t.at(i).value.fileDestination ', this.t.at(i).value.fileCodeFilter)
      let index = i + 1;
      let errMsg = "";
      if (this.t.at(i).value.fileCodeFilter === "") {
        console.log('Skipping the record as either one of the required fields fileCodeFilter is missing');
        this.mandatoryFieldErrMsg = "File Code Filter is missing. Please check and try again...";
        errMsg += "File Code Filter";
        this.uploadFilesError = true;
      }
      if (this.t.at(i).value.fileTypeCode === "") {
        console.log('Skipping the record as either one of the required fields fileTypeCode is missing');
        if (errMsg != "") {
          errMsg += ",";
        }
        errMsg += "FileTypeCode"
        this.uploadFilesError = true;
      }
      if (this.t.at(i).value.fileNameWithPath == undefined || this.t.at(i).value.fileNameWithPath === "") {
        console.log('Skipping the record as either one of the required fields fileNameWithPath is missing')
        if (errMsg != "") {
          errMsg += ",";
        }
        errMsg += " File"
        this.uploadFilesError = true;
      }
      /*       if(this.t.at(i).value.fileNameWithPath == undefined || this.t.at(i).value.fileTypeCode === ""
                ||  this.t.at(i).value.fileCodeFilter === "" || this.t.at(i).value.fileNameWithPath === "" ){
                  console.log('Skipping the record as either one of the required fields are missing')
                  this.uploadFilesError = true
                  // this.uploadFilesErrorMsg = "Fields missing, check and try again"
                  continue;
                } */
      /*       if(this.t.at(i).value.fileTypeCode === ""
            ||  this.t.at(i).value.fileCodeFilter === "" || this.t.at(i).value.fileNameWithPath === ""
      ){
        this.uploadFilesError = true
                  console.log('Skipping the record as either one of the required fields are missing')
                  continue;
                  // validation
                } */
      if (errMsg != "") {
        console.log("Upload Files Error " + this.uploadFilesError);
        errMsg = "Row " + index + "- Missing: " + errMsg;
        this.fileExtensionRowErr.push(errMsg);
        continue;
      }
      console.log('Value ', this.t.at(i).value)
      console.log('Digital Sign ', this.t.at(i).value.digitalSign)
      let digitalSign: boolean = false;
      if (this.t.at(i).value.digitalSign == undefined) {
        digitalSign = false;
      } else {
        digitalSign = this.t.at(i).value.digitalSign
      }
      localPartAttRes = this.partAttRes.filter(a => a.fileTypeCode === this.t.at(i).value.fileTypeCode);
      let partRes = 0;
      if (localPartAttRes.length > 0) {
        errMsg += " File Type Code "
        partRes = 1;
        this.uploadFilesError = true;
      }
      let accOffFileName=this.t.at(i).value.fileNameWithPath.substring(this.t.at(i).value.fileNameWithPath.lastIndexOf("\\") + 1);
      if(this.accToggleValue===false){
        console.log("File Name "+this.t.at(i).value.fileSource.name);
        accOffFileName=this.t.at(i).value.fileSource.name;
      }
      localPartAttRes = this.partAttRes.filter(a => a.fileName === accOffFileName);
      if (localPartAttRes.length > 0) {
        if (partRes == 1) {
          errMsg += ",";
        }
        errMsg += " File Name "
        partRes = 1;
        this.uploadFilesError = true;
      }
      if (partRes) {
        errMsg += " exists in part Attachment"
      }
      let duplicate = 0;
      if (!tempFileTypeCodes.includes(this.t.at(i).value.fileTypeCode)) {
        tempFileTypeCodes.push(this.t.at(i).value.fileTypeCode);
      }
      else {
        if (partRes) {
          errMsg += ",";
        }
        errMsg += " Duplicate File Type Code";
        duplicate = 1;
        this.uploadFilesError = true;
      }
      if (!tempFileNames.includes(accOffFileName)) {
        tempFileNames.push(accOffFileName);
      }
      else {
        if (partRes || duplicate) {
          errMsg += ",";
        }
        if (!duplicate) {
          errMsg += " Duplicate";
        }
        errMsg += " File Name ";
        duplicate = 1;
        this.uploadFilesError = true;
      }
      if (duplicate) {
        errMsg += " in selection";
      }
      this.onChangeFileTypeCode(i, true);
      let currFileExt: string = accOffFileName;
      console.log("Curr File Txt ", currFileExt.toLowerCase().substring(currFileExt.lastIndexOf(".")));
      currFileExt = currFileExt.toLowerCase().substring(currFileExt.lastIndexOf("."));
      let wrgExt = 0;
      console.log('Current File Extension ',currFileExt)
      console.log('File Extensions ',this.fileExtension)
      console.log('File Extension includes ',this.fileExtension.includes(currFileExt))
      if (!this.fileExtension.includes(currFileExt) && !this.fileExtension.includes(".all" || ".ALL" || "all" || "ALL")) {
        console.log("One of the records file extension doesn't match with file Type Code");
        if (partRes || duplicate) {
          errMsg += ",";
        }
        errMsg += " Allowed File Extensions are for file type code \"" + this.t.at(i).value.fileTypeCode + "\" are " + this.fileExtension;
        wrgExt = 1;
        this.uploadFilesError = true;
      }
      if (partRes || duplicate || wrgExt) {
        errMsg = "Row " + index + "- Error: " + errMsg;
        this.fileExtensionRowErr.push(errMsg);
      }

      if (!this.uploadFilesError && this.fileExtensionRowErr.length === 0) {

        if (this.accToggleValue == false) {
          let fileName: string = this.t.at(i).value.fileNameWithPath;
          fileName = fileName.substring(fileName.lastIndexOf("\\") + 1)
          console.log('File Name ', fileName)
          this.uploadFileInfo.push(
            {
              swbNumber: this.dataService.getUrlParams().partNumber,
              swbRev: this.dataService.getUrlParams().partRevision,
              fileName: fileName,
              fileTypeCode: this.t.at(i).value.fileTypeCode,
              fileDestination: this.t.at(i).value.fileCodeFilter,
              digitalSign: digitalSign,
              file: this.t.at(i).value.fileSource
            })
        } else {
          this.uploadFileInfo.push(
            {
              swbNumber: this.dataService.getUrlParams().partNumber,
              swbRev: this.dataService.getUrlParams().partRevision,
              fileName: this.t.at(i).value.fileNameWithPath,
              fileTypeCode: this.t.at(i).value.fileTypeCode,
              fileDestination: this.t.at(i).value.fileCodeFilter,
              digitalSign: digitalSign
            })
        }
      }
    }
    console.log("File Extension Arr " + this.fileExtensionRowErr);
  

      
    if (!this.uploadFilesError && this.fileExtensionRowErr.length === 0 ) {
      if (this.accToggleValue == false) {

      //********************************************************************/
      //------------------------- Non - Accelerated Transfer ----------------
      //********************************************************************/
        this.dataService.setAgileFileInfo(this.uploadFileInfo);
        this.uploadFileInfo.forEach((uploadInfo) => {
          console.log('upload file info ',uploadInfo)
          let uploadFile:UploadStatusModel;
          uploadFile = {
            fileName : uploadInfo.fileName,
            fileNameWithPath:uploadInfo.fileName,
            fileCacheStatus : this.notStartedStatus,
            acceleratedTransfer:false,
            file:uploadInfo.file,
            avScanStatus : this.notStartedStatus,
            agileUploadStatus : this.notStartedStatus,
            statusPanelEnabled : false,
            fileCacheMessage : {Transfer_Rate:'NA',
            Current_Percent:'NA',
            Transfer_Mode:'NA',
            Time_Remaining:'NA'},
            avsScanMessage : 'Not Started',
            agileUploadMessage : 'Not Started',
            server:0
          }
          this.dataService.addToUploadFiles(uploadFile);
        })
        this.router.navigate(['transferstatus_v2'], { skipLocationChange: true })
        
      } else {

      //********************************************************************/
      //------------------------- Accelerated Transfer ---------------------
      //********************************************************************/

        
          console.log('Upload files info ', this.uploadFileInfo);
          this.uploadFileInfo.forEach((value) => {
            this.dataService.pushToAgileFileInfo(value);
          })
        console.log('in Upload files ', this.attachmentInfoDynamicForm.value);
        console.log('Selected Files ', this.selectedFiles);
        console.log('Selected Files string ', this.selectedFilesString);



        if (this.selectedFilesString.length > 0) {
          console.log('Initiating FC Connection ')
          console.log('Selected Files String length ', this.selectedFilesString.length)
          for (let i = 0; i < this.selectedFilesString.length; i++) {
            console.log('index ', i)
            if (this.selectedFilesString[i] == undefined) {
              console.log('removing at index ', i)
              this.selectedFilesString.splice(i, 1);
            }
          }


          console.log('Selected Files String after cleanup ', this.selectedFilesString)
          // let result = window.confirm('please make sure that the Transfer Agent is started');
          // if(result){
            this.initiateFCConnectionAndTransfer();
          // }
          
        }
      }

      // console.log(this.uploadFileInfo.filter((value) => value.fileName == '40MBTest.exe'))

    }


  }

  initiateFCConnectionAndTransfer() {
    this.uploadLoadingModalMessage = 'Creating connection...'
    this.openProgressBar()
    this.fcService.getFCUploadConnection().subscribe(
      data => {
        console.log(data)
        console.log('data connection Key', data.connectionKey)
        if (data.connectionKey != undefined) {
          this.uploadLoadingModalMessage = 'Initiating transfer...'
          this.dataService.setFCConnectionKey(data.connectionKey);
          this.initiateFCTransfer(data.connectionKey);
        }

      }
    )
  }

  initiateFCTransfer(connectionKey: string) {

    this.fcService.initiateFCUploadTransfer(connectionKey, this.selectedFilesString).subscribe(
      data => {
        console.log('Transfer Initiation Data ', data);
        console.log('Transfer Job Id ', data.jobId);

        // // check if the All transfers is Initiated
        // this.fcService.getAllTransferStatus().subscribe((data) => {
        //   console.log('All Transfer Status response ',data)

        // })
        if (data.jobId != undefined) {
          // this.dialog.closeAll();
          this.closeProgresBar();
          this.dataService.pushToFilesToUpload(this.selectedFilesString);
          this.dataService.addToTransferRequest(data);

          this.selectedFilesString.forEach((fileName) => {
            let uploadFile:UploadStatusModel;
          uploadFile = {
          fileName : fileName.substring(fileName.lastIndexOf('/')+1),
          fileNameWithPath:fileName,
          fileCacheStatus : this.notStartedStatus,
          acceleratedTransfer:true,
          avScanStatus : this.notStartedStatus,
          agileUploadStatus : this.notStartedStatus,
          statusPanelEnabled : false,
          fileCacheMessage : {Transfer_Rate:'NA',
          Current_Percent:'NA',
          Transfer_Mode:'NA',
          Time_Remaining:'NA'},
          avsScanMessage : 'Not Started',
          agileUploadMessage : 'Not Started',
          jobid:data.jobId,
          server:0
            }
            this.dataService.addToUploadFiles(uploadFile);
          })

          

          this.router.navigate(['transferstatus_v2'], { skipLocationChange: true })

          // this.router.navigate(['file-transfer-status'])
        }
      }
    )
  }

  enterFileName(fileExplorerOut: FileExplorerOut): void {
    // console.log(fileNamePath)
    // this.fileNameTest = fileNamePath
    console.log('enterFile Name method ', fileExplorerOut.fileElement)
    // let fileNamePathSplit = fileNamePath.split("::");
    this.t.at(fileExplorerOut.index).patchValue({ fileNameWithPath: fileExplorerOut.fileElement.name })

    this.selectedFiles.push(fileExplorerOut.fileElement);
    console.log('Value at 0 ', this.selectedFilesString[0]);
    console.log('Value at index ', this.selectedFilesString[fileExplorerOut.index]);
    this.selectedFilesString[fileExplorerOut.index] = fileExplorerOut.fileElement.path;
    console.log('Here 1')
    // if(this.selectedFilesString.indexOf(fileExplorerOut.fileElement.path) < 0){


    //   this.selectedFilesString.push(fileExplorerOut.fileElement.path);

    // }


    // this.f.get('fileNameWithPath').setValue(fileNamePath)
    // this.f['fileNameWithPath'].setValue(fileNamePath);
  }

  onFileDestinationChange(index: number) {
    console.log('Selected Val ', this.t.at(index).value.fileCodeFilter)
  }
  openProgressBar() {
    this.bodyText = "yyy";
    let btn = document.getElementById("uploadprogressbar");
    // let btn = document.getElementById("modalbutton");
    btn.click();


  }

  closeProgresBar() {
    let clsBtn = document.getElementById("closeUploadModal");
    clsBtn.click();
  }

  // fileTypeCodeChange(i) {
  //   // 'DI:DUP Inventory Module'
  //   console.log('File Type Code ', this.t.at(i).get('fileTypeCode').value)
  //   if (this.t.at(i).get('fileTypeCode').value == 'DI:DUP Inventory Module') {
  //     this.t.at(i).get('digitalSign').enable();
  //   }
  // }

  /*   getFileTypeCodeRes(){
    this.agileService.getFileTypeCodesDropDown().subscribe(
      (data) =>
      {
        this.fileTypeCodeRes=data;
        console.log("File Type Code ",this.fileTypeCodeRes);
      })
  } */

  getFileExtension(): string[] {
    //console.log("File Extension "+this.fileExtension);
    // if (this.fileExtension != undefined)
      // console.log('File Extension string ', this.fileExtension.toString())
    return this.fileExtension;
  }

  getFileExtensionString(): string {
    //console.log("File Extension "+this.fileExtension);

    return this.fileExtension != undefined ? this.fileExtension.toString() : "";


  }

  /*   getDigitalSign(index: number) {
      this.t.at(index).get('fileNameWithPath').setValue("");
      let fileTypeCode = this.t.at(index).value.fileTypeCode;
      if (fileTypeCode != "") {
        console.log("File Type Code ", fileTypeCode)
        let localFileTypeRes = [];
        localFileTypeRes = this.fileTypeCodeRes.filter(a => (a.fileTypeCode === fileTypeCode));
        console.log("File Type Res ", localFileTypeRes);
        if (localFileTypeRes[0].digitalSign == 1) {
          console.log("Digital Sign 1");
          this.t.at(index).get('digitalSign').enable();
        }
        this.fileExtension = localFileTypeRes[0].extension;
        console.log("Digital Sign Extension " + this.fileExtension);
      }
  
  
    } */

  onChangeFileTypeCode(index: number, upload: boolean) {
    if (upload === false) {
      this.t.at(index).get('fileNameWithPath').setValue("");
    }
    if (this.t.at(index).value.fileTypeCode !== "") {
      this.t.at(index).get('fileNameWithPath').enable();
    }
    let localFileTypeRes = [];
    localFileTypeRes = this.dataService.getDigitalSign(this.t.at(index).value.fileTypeCode);
    if (localFileTypeRes[0].digitalSign == 1) {
      console.log("Digital Sign 1");
      this.t.at(index).get('digitalSign').enable();
    }
    let resFileExt = localFileTypeRes[0].extension + '';
    this.fileExtension = resFileExt.split(",").map(function (value) {
      return value.trim();
   });

    // resFileExt.split(',').forEach((ext) => {
    //   this.fileExtension.push(ext.trim());
    // });
    console.log("Digital Sign Extension " + this.fileExtension);
  }


  onChangeFileCodeFilter() {

    if (this.fileTypeCodeRes.length === 0) {
      this.fileTypeCodeRes = this.dataService.getFileTypeCodes();
    }
    else {
      console.log("Not Invoked");
    }
  }

  // checkTAStatus():boolean{
  //   let statusIntvSubc : Subscription;
  //   let statusInterval = interval(2000);
  //   let taStarted:boolean = false;
  //   statusIntvSubc = statusInterval.subscribe(() => {
  //     this.fcService.getTransferAgentHeartBeat().subscribe(
  //       (response)=> {
  //         console.log('response from heart beat service ',response)
  //         if(response.status != "OK")
  //         {
  //           // console.log('Open File Catalyst')
  //           window.open("filecatalyst:",'_self');
           
  //         //  this.openTAModal();
  //          // Installed, but not turned on
  //          // Not installed
  //         }else
  //         {
           
  //           statusIntvSubc.unsubscribe();
  //           taStarted = true;
  //           // this.closeTAModal();
            
  //         }
  //       },
  //       (error)=>
  //       { console.log('error from heart beat service ',error)
       
  //       // console.log('Open File Catalyst')
  //       // window.open("filecatalyst:",'_self');
  //         // this.openTAModal();
  //         // console.log('error from heart beat service ',error)
  //         // let flag = this.dataService.getToggleValue()
  //         // if(error.status != "OK" && flag==true)
  //         // {
  //         //   this.openTAModal();
  //         // }else
  //         // {
  //         //   this.closeTAModal();
  //         // }
  
  //       }
  //     )
  //   })
  
  //   return taStarted;
  // }

}
